















import FormBase from "../../../general/abstract/form/FormBase.vue";
import CustomerFormTemplate from "./CustomerFormTemplate.vue";
import Component, { mixins } from "vue-class-component";
import { IdResponse } from "@/common/model/IdResponse";
import { CustomerFormModel } from "@/context/customer/model/CustomerFormModel";
import { VModel } from "vue-property-decorator";
import Form from "@/general/abstract/form/mixin/Form";
import { customerApi } from "@/context/customer/api/CustomerApi";
import { customerRouter } from "@/context/customer/router/CustomerRouter";

@Component({
  components: {
    CustomerFormTemplate,
    FormBase
  }
})
export default class CustomerForm extends mixins<
  Form<CustomerFormModel, CustomerFormModel, IdResponse>
>(Form) {
  @VModel({ default: new CustomerFormModel() }) model!: CustomerFormModel;

  buildCmd(): CustomerFormModel | Record<string, unknown> {
    if (this?.model?.id) {
      return this.model;
    }
    let command: Record<string, unknown> = Object.assign<
      Record<string, unknown>,
      CustomerFormModel
    >({}, this.model);
    delete command.id;
    return command;
  }

  async submitApi(cmd: CustomerFormModel): Promise<IdResponse> {
    const response: IdResponse = cmd.id
      ? await customerApi.update<CustomerFormModel, IdResponse>(cmd)
      : await customerApi.create<CustomerFormModel, IdResponse>(cmd);
    return response;
  }

  showRoute(id: number): Record<string, unknown> {
    return customerRouter.show(id);
  }
}
